<template>
  <div>
    <b-modal
      title="Asset was registered"
      class="modal-success"
      v-model="successModal"
      ok-only
      ok-variant="success"
      @ok="refreshGridData"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >Asset script was successfully registered with your Shopify store. You should be able to see it now.</b-modal>
    <b-modal
      title="Error happened"
      class="modal-danger"
      v-model="errorModal"
      ok-only
      ok-variant="danger"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >{{errorMessage}}</b-modal>
    <kendo-datasource
      ref="grid-datasource"
      :transport="transport"
      :schema="schema"
      :serverPaging="true"
      :serverSorting="true"
      :page-size="5"
      :sort="sort"
    ></kendo-datasource>
    <kendo-grid
      :data-source-ref="'grid-datasource'"
      ref="grid"
      :selectable="'row'"
      :sortable="sortable"
      :filterable="false"
      :groupable="false"
      :toolbar="toolbarTemplate"
      :pageable="pageable"
      :pageable-always-visible="true"
      :auto-bind="true"
    >
      <kendo-grid-column title="Register with Shopify" :width="220" :template="registerTemplate"></kendo-grid-column>
      <kendo-grid-column title="Generated on" field="generationDate" :template="generatedTemplate"></kendo-grid-column>
      <kendo-grid-column
        field="isUsed"
        title="In use in the store"
        :width="170"
        :template="inUseTemplate"
      ></kendo-grid-column>
    </kendo-grid>
  </div>
</template>

<script>
import Vue from "vue";
import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
import { Grid, GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSource, DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper'
import { format, render, cancel, register } from 'timeago.js';

import Template from "./RecommenderGridRegisterWithShopifyColumn";
var regTemplate = Vue.component(Template.name, Template);

Vue.use(GridInstaller);
Vue.use(DataSourceInstaller)


export default {
  name: "recommendergrid",
  props: {
    type: String,
    shopifyStoreId: String
  },
  data: function () {
    var self = this;
    return {
      successModal: false,
      errorModal: false,
      errorMessage: "",
      pageable: {
        refresh: false,
        pageSizes: [5, 10, 50],
        messages: {
          display: "{0}-{1} of {2} snapshots",
          itemsPerPage: "snapshots per page"
        }
      },
      sortable: {
        allowUnsort: false,
        mode: "single"
      },
      transport: {
        read: async (options) => {
          try {
            let response = await Vue.axios.get(process.env.VUE_APP_API_URL + `shopify/list-recommenders/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${self.type}/${self.shopifyStoreId}?take=${options.data.take}&skip=${options.data.skip}&orderby=${options.data.sort[0].field}&desc=${options.data.sort[0].dir == 'desc'}`);
            options.success(response.data);
          }
          catch (error) {
            debugger
            console.log(error.statusText);
            options.error(error.statusText);
          }
        }
      },
      schema: {
        data: function (data) {
          return data.items;
        },
        model: {
          id: "id",
          fields: {
            id: { from: "id" },
            generationDate: { from: "generationDate", type: "date" },
            isUsed: { from: "isUsed", type: "boolean" },
          }
        },
        total: function (data) {
          return data.total;
        }
      },
      sort: {
        field: "generationDate",
        dir: "desc"
      }
    };
  },
  mounted: function () {
    let self = this;
    var grid = this.$refs.grid.kendoWidget();
    var toolbarEl = grid.element.find('.k-grid-toolbar');
    toolbarEl.on("click", ".k-pager-refresh", function (e) {
      e.preventDefault();
      grid.dataSource.read();
    });

  },
  methods: {
    generatedTemplate(e) {
      return format(e.generationDate);
    },
    inUseTemplate(e) {
      return e.isUsed ? "<span class=\"k-icon k-i-check k-i-checkmark\"></span>" : "";
    },
    registerTemplate: function (e) {
      let self = this
      return {
        template: regTemplate,
        templateArgs: async function () {
          try {
            let response = await Vue.axios.post(new URL(process.env.VUE_APP_API_URL + `shopify/bought-together-js-recommender/register`),
              {
                recommenderId: e.id,
                shopifyStoreId: self.shopifyStoreId,
                applicationName: process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME
              });
            self.$data.successModal = true;
            self.refreshGridData();
          } catch (error) {
            self.$data.errorMessage = error.response ? error.response.data : "Adding recommender to your store failed.";
            self.$data.errorModal = true;
          }
        }
      }
    },
    refreshGridData: function () {
      var grid = this.$refs.grid.kendoWidget().dataSource.read();;
    },
    toolbarTemplate: function () {
      var templateHtml =
        "<span>" +
        '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
        "</span>";
      return kendo.template(templateHtml);
    },
    onChange: function (ev) {
      var selected = $.map(ev.sender.select(), function (item) {
        return $(item).text();
      });

      console.log(
        "Selected: " +
        selected.length +
        " item(s), [" +
        selected.join(", ") +
        "]"
      );
    }
  }
};
</script>
<<style lang="scss">
@import "@/styles/grid.scss";


</style>